import * as THREE from 'three'
import { bezier2D } from '../../Utils/Bezier'
import Experience from '../../Experience'
import { ParametricGeometry } from 'three/examples/jsm/Addons.js'
import anim from '../../Utils/Anim'
import vertexShader from '../../../shaders/lava/vertex.glsl'
import fragmentShader from '../../../shaders/lava/fragment.glsl'
export default class Lava {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.ui = this.experience.debug.ui
        this.position = _options.position
        this.noise = _options.noise
        this.noise.wrapS = THREE.RepeatWrapping
        this.noise.wrapT = THREE.RepeatWrapping


        // 
        this.P1 = [0.1, 1]
        this.P2 = [0.1, 0.5]
        this.P3 = [0.1, 0]
        this.P4 = [1, 0]
        // 
        this.setMesh()
        this.setDebug()
    }
    getRadius(v) {

        return bezier2D(v, this.P1[0], this.P2[0], this.P3[0], this.P4[0], this.P1[1], this.P2[1], this.P3[1], this.P4[1]).x
    }
    getHeight(v) {

        return bezier2D(v, this.P1[0], this.P2[0], this.P3[0], this.P4[0], this.P1[1], this.P2[1], this.P3[1], this.P4[1]).y
    }
    setMesh() {
        this.geometry = new ParametricGeometry((u, v, target) => {
            let radius = 1
            let x = Math.cos(u * Math.PI * 2) * this.getRadius(v)
            let y = this.getHeight(v) - 1
            // let y = Math.min((v - 0.5) * 1, 0.5)
            // let y = (v - 0.5)
            let z = Math.sin(u * Math.PI * 2) * this.getRadius(v)
            target.set(x, y, z)
        }, 252, 32);
        this.geometry.computeVertexNormals()
        // this.material = new THREE.MeshNormalMaterial({ side: THREE.DoubleSide, wireframe: false })
        this.material = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,

            wireframe: false,
            transparent: true,
            uniforms: {
                u_time: new THREE.Uniform(0),
                u_amplitude: new THREE.Uniform(0.5),
                u_powerShine: new THREE.Uniform(0.1),
                u_noiseTexture: new THREE.Uniform(this.noise),
            }
        })
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.copy(this.position)
        this.mesh.layers.enable(1)
        this.mesh.scale.set(0.14, 0.2, 0.14)
        // this.mesh.scale.set(0.5, 0.5, 0.5)
        this.scene.add(this.mesh)


    }
    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            this.lavaFolder = ui.addFolder('lava')
            this.lavaFolder.add(this.mesh.position, "x").min(-2).max(2).step(0.001)
            this.lavaFolder.add(this.mesh.position, "y").min(-2).max(2).step(0.001)
            this.lavaFolder.add(this.mesh.position, "z").min(-2).max(2).step(0.001)
            this.lavaFolder.add(this.mesh.scale, "y").min(0).max(0.5).step(0.001)
        }
    }
    destroy() {
        // Retirer le maillage de la scène
        if (this.scene && this.mesh) {
            this.scene.remove(this.mesh);
        }

        // Nettoyer la géométrie
        if (this.geometry) {
            this.geometry.dispose();
        }

        // Nettoyer le matériau
        if (this.material) {
            // Si des textures sont utilisées, les libérer aussi
            if (this.material.uniforms.u_noiseTexture && this.material.uniforms.u_noiseTexture.value) {
                this.material.uniforms.u_noiseTexture.value.dispose();
            }
            this.material.dispose();
        }

        // Nettoyer tout ce qui pourrait nécessiter un nettoyage supplémentaire
        if (this.ui) {
            this.lavaFolder.destroy()
        }

    }

    update() {
        if (this.material) {
            this.material.uniforms.u_time.value = this.time.elapsed * 0.001

        }

    }

}